import React, { useState } from 'react'
import axios from 'axios'
import ImageUploader from './ImageUploader'
import { Container, Form, FormField, Input, Segment, TextArea, Button, Icon } from 'semantic-ui-react'

const GameDetails = ({ savedDict, onStateChange }) => {
    const [name, setName] = useState(savedDict.name)
    const [tagline, setTagline] = useState(savedDict.tagline)
    const [description, setDescription] = useState(savedDict.description)
    const [gameImage, setGameImage] = useState(savedDict.gameImage)
    const [aboutThisGame, setAboutThisGame] = useState(savedDict.aboutThisGame)
    const [faq, setFaq] = useState(savedDict.faq)
    const [platforms, setPlatforms] = useState(savedDict.platforms)

    const handleChangeField = e => {
        const { value } = e.target
        const fieldName = e.target.name
        const updates = { name, tagline, description, gameImage, aboutThisGame, faq, platforms }
        updates[fieldName] = value
        if (fieldName === 'name') setName(value)
        if (fieldName === 'tagline') setTagline(value)
        if (fieldName === 'description') setDescription(value)
        if (fieldName === 'aboutThisGame') setAboutThisGame(value)
        if (fieldName === 'platforms') setPlatforms(value)
        onStateChange(updates)
    }

    const handleChangeFieldFAQ = (e, index) => {
        const { name, value } = e.target
        const updatedFaq = [...faq]
        updatedFaq[index] = { ...updatedFaq[index], [name.toLowerCase()]: value }
        setFaq(updatedFaq)
        onStateChange({ name, tagline, description, gameImage, aboutThisGame, faq: updatedFaq, platforms })
    }

    const handleAddNewFAQ = () => {
        const updatedFaq = [...faq, { question: '', answer: '' }]
        setFaq(updatedFaq)
        onStateChange({ name, tagline, description, gameImage, aboutThisGame, faq: updatedFaq, platforms })
    }

    const handleUploadClicked = async file => {
        const s3link = await uploadToS3(name + '-gameImage', file)
        setGameImage(s3link)
        onStateChange({ name, tagline, description, gameImage: s3link, aboutThisGame, faq, platforms })
    }

    const renderFAQs = () => {
        if (!faq) return null
        const rows = []
        for (const [i, faqItem] of faq.entries()) {
            rows.push(
                <Segment inverted key={i} style={{ border: '1px solid #444', padding: 20 }}>
                    <FormField control={Input} label='Question' name='Question' value={faqItem.question} placeholder='Question' onChange={e => handleChangeFieldFAQ(e, i)} inverted className="dark-theme-input"/>
                    <FormField style={{ marginBottom: 5 }} control={TextArea} rows='6' label='Answer' name='Answer' value={faqItem.answer} placeholder='Answer' onChange={e => handleChangeFieldFAQ(e, i)} inverted className="dark-theme-textarea-field"/>
                </Segment>
            )
        }
        return rows
    }

    return (
        <Container inverted style={{ background: '#1b1c1d' }}>
            <ImageUploader url={gameImage} uploadClicked={handleUploadClicked} />
            <Form inverted style={{ marginTop: 25 }}>
                <FormField control={Input} label='Name' name='name' value={name} placeholder='' onChange={handleChangeField} className="dark-theme-input"/>
                <FormField control={Input} label='Tagline' name='tagline' value={tagline} placeholder='' onChange={handleChangeField} className="dark-theme-input"/>
                <FormField control={Input} label='Platform' name='platforms' value={platforms} placeholder='' onChange={handleChangeField} className="dark-theme-input"/>
                <FormField control={TextArea} rows='8' label='Description' name='description' value={description} placeholder='' onChange={handleChangeField} className="dark-theme-textarea-field"/>
                <FormField control={TextArea} rows='6' label='About this Game' name='aboutThisGame' value={aboutThisGame} placeholder='' onChange={handleChangeField} className="dark-theme-textarea-field"/>
                <h4 style={{ color: 'white' }}>FAQ</h4>
                {renderFAQs()}
            </Form>
            <Button inverted color='blue' style={{ marginTop: 20 }} onClick={handleAddNewFAQ}><Icon name='add'/>Add New FAQ</Button>
        </Container>
    )
}

const uploadToS3 = async (name, file) => {
    let prefixStr = name
    try {
        const response = await axios.post('/api/generate-s3-bucket-url', {
            fileName: prefixStr + '-' + file.name,
            fileType: file.type,
        })
        const presignedUrl = response.data.presignedUrl
        await axios.put(presignedUrl, file, { headers: { 'Content-Type': file.type } })
        const fileUrl = presignedUrl.split('?')[0]
        console.log('File uploaded successfully to: ' + fileUrl)
        return fileUrl
    } catch (error) {
        console.error('Error uploading file:', error)
        return null
    }
}

export default GameDetails